import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center relative z-10">
        <h2 className="text-3xl md:text-5xl font-extrabold text-foreground-950 font-heading">
          免费畅读无删减韩漫
        </h2>
        <p className="mt-4 text-foreground-500 text-sm md:text-base max-w-md mx-auto">
          下拉式阅读，高清全彩，无需注册，即刻开始你的韩漫之旅
        </p>
        <Link
          to="/category/romance"
          className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors text-sm cursor-pointer whitespace-nowrap"
        >
          立即免费阅读
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="absolute bottom-0 left-0 right-0 flex justify-center gap-3 md:gap-6 opacity-30">
        {['secretary-escape', 'demon-lord', 'warrior-rebirth', 'bl-spring', 'bakery-love'].map((slug) => (
          <div key={slug} className="w-16 md:w-24 h-20 md:h-32 rounded-t-lg bg-background-200 overflow-hidden translate-y-1/3">
            <div className="w-full h-full bg-background-300"></div>
          </div>
        ))}
      </div>
    </section>
  );
}